import { Plugin } from "prosemirror-state";
import { Extension } from "../../core/extension";
import { isReactNativeWebViewContext, postMessage } from "./integration";
/**
 * Provides integration with `react-native-webview` by sending callback messages via `window.ReactNativeWebView.postMessage`
 */
export class ReactNativeWebViewIntegrationExtension extends Extension {
    addPlugins(schema, plugins) {
        if (!isReactNativeWebViewContext()) {
            return plugins;
        }
        return plugins.concat([
            new Plugin({
                appendTransaction: (trs, oldState, newState) => {
                    postMessage({
                        type: "change",
                        doc: newState.doc.toJSON(),
                        selection: newState.selection.toJSON(),
                    });
                    return null;
                },
                props: {
                    handleDOMEvents: {
                        focus: () => {
                            postMessage({ type: "focus" });
                            return false;
                        },
                        blur: () => {
                            postMessage({ type: "blur" });
                            return false;
                        },
                    },
                },
            }),
        ]);
    }
}
